@if (color(); as color) {
    <div class="relative">
        <div class="px-3 py-2">
            <div
                class="rounded-full cursor-pointer size-8"
                [style]="{ 'background-color': color || '#1693C9' }"
                (click)="setColor.emit(color)"
            ></div>
        </div>
        @if (removeMode()) {
            <button
                (click)="handleRemove($event)"
                class="absolute top-0 -right-1 size-4 bg-gray-300 rounded-full flex items-center justify-center"
            >
                <p class="text-xs text-gray-800">-</p>
            </button>
        }
    </div>
}
